import { render, staticRenderFns } from "./FormNav.vue?vue&type=template&id=2e56cd72&scoped=true&"
import script from "./FormNav.vue?vue&type=script&lang=js&"
export * from "./FormNav.vue?vue&type=script&lang=js&"
import style0 from "./FormNav.vue?vue&type=style&index=0&id=2e56cd72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56cd72",
  null
  
)

export default component.exports